// extracted by css-extract-rspack-plugin
export default {"BaseCell":"dropdown-cell-module__BaseCell__KZn6XIl"};